module.exports = __webpack_public_path__ + "static/media/multi-platform-moduleD3.994ed51a.png";